import service from '../../utils/Service';

const addEventAction = (newEvent, userData)  => {
   return {
      type: 'ADD_EVENT',
      payload: service.addEvent(newEvent, userData)
   }
}

export default addEventAction;



// WEBPACK FOOTER //
// ./src/actions/events/addEventAction.js